import React from 'react';
import Markdown from 'markdown-to-jsx';

import Spinner from '../../components/Spinner';

export enum AIThreadItemType {
  Question,
  Answer,
}

export interface AIThreadItem {
  key: string;
  type: AIThreadItemType;
  messages: { key: string, message: string }[];
}

interface AIThreadProps {
  value: AIThreadItem[];
  loading: string | undefined;
  onLetsGo: () => void;
}

const markdownOptions = {
  overrides: {
    a: {
      props: {
        target: '_blank',
      },
    },
  },
};

export default function AIThread({ loading, value, onLetsGo }: AIThreadProps) {
  return (
    <div className="ai-thread">
      {
        !loading && value.length === 0 && (
          <div className="ai-ask-question">
            <p>
              Welcome to the Flip RFI Assistant! Feel free to ask a question
              above or click the button below to get started!
            </p>
            <button type="button" onClick={onLetsGo}>🚀 Let&apos;s go!</button>
          </div>
        )
      }
      {
        loading && (
          <>
            <div className="ai-right">
              <div className="ai-question">{loading}</div>
            </div>
            <div className="ai-left">
              <div className="ai-loading">
                <Spinner />
              </div>
            </div>
          </>
        )
      }
      {
        value.map((v) => {
          if (v.type === AIThreadItemType.Question) {
            return (
              <div className="ai-right" key={v.key}>
                <div className="ai-question">{v.messages[0].message}</div>
              </div>
            );
          }

          return (
            <div className="ai-left" key={v.key}>
              <div className="ai-answer-group">
                {
                  v.messages.map((m) => (
                    <div className="ai-answer" key={`${m.key}`}>
                      <Markdown options={markdownOptions}>{m.message}</Markdown>
                    </div>
                  ))
                }
              </div>
            </div>
          );
        })
      }
    </div>
  );
}
